var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7498 14.6667V9.45842C14.7498 6.2605 13.0519 3.58341 10.0623 2.87508V2.16675C10.0623 1.30216 9.36442 0.604248 8.49984 0.604248C7.63525 0.604248 6.93734 1.30216 6.93734 2.16675V2.87508C3.95817 3.58341 2.24984 6.25008 2.24984 9.45842V14.6667L0.166504 16.7501V17.7917H16.8332V16.7501L14.7498 14.6667ZM8.49984 20.9167C9.64567 20.9167 10.5832 19.9792 10.5832 18.8334H6.4165C6.4165 19.9792 7.354 20.9167 8.49984 20.9167ZM4.33317 15.7084H12.6665V9.45841C12.6665 6.87508 11.0936 4.77091 8.49984 4.77091C5.90609 4.77091 4.33317 6.87508 4.33317 9.45841V15.7084Z",
    fill: "#BDBDBD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.00b08e535571a87859cba0027456ada9.svg";
export { ForwardRef as ReactComponent };